export default "__VITE_ASSET__BfEOF2fg__"